
<div>
  <slot></slot>
  <p v-if="objectModelAction.linked_process_flow_id">
    Run
    <a :href="RouteHelper.path({route: Route.editProcessFlow, modelOrId: objectModelAction.linked_process_flow_id})" target="_blank" class="btn-link">
      {{objectModelAction.linked_process_flow_title}}
    </a>
  </p>
</div>
